<!-- 社区活动次数统计柱状图 -->
<template>
    <div class="nodataBox" v-if="nodata">暂无数据</div>
    <div :id="'echart4'+index" style="width:100%;height:100%" v-else></div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    inject:['isSmallWidth'],
    data() {
    //这里存放数据
        return {
            nodata:false,
            ids:[],
            color:['#ff7d7d','#ffc700']
        };
    },
  props:{
    index:{
      type:null,
      default:0,
    },
    token:{
      type:String,
      default: ''
    }
  },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            var url = this.urlobj.communityActivityNum

            this.$get(url,{},{
              token:this.token || this.$store.state.access_token
            }).then(res => {
                if (res.isSucceed) {
                let data = res.rows
                   if(!data.length){
                       this.nodata = true;
                         return
                   }
                  //丛台需求，需要过滤掉为0的数据
                  data = data.filter(item=>item.dyCount || item.jmCount)
                  
                   if(data.length>5) data = data.slice(0,5)

                   data.forEach(item=>{
                       item.communityName = item.communityName.indexOf('社区')>-1?item.communityName.split('社区')[0]:item.communityName.split('街道')[0]+'街道'
                   })
                   this.ids = data.map(item=>item.communityId)
                  var ecdata = {
                    label:data.map(item=>item.communityName),
                    dyCount:data.map(item=>item.dyCount?item.dyCount:0),
                    jmCount:data.map(item=>item.jmCount?item.jmCount:0),
                  }
                  if (!this.token) {
                    this.initEcharts(ecdata)
                  }else {
                    this.initCongtaiEcharts(ecdata)
                  }
                } else {

                }
            }).catch(e => {
            })
        },
        initEcharts (ecdata) {
          var id = 'echart4' + this.index
            var echart = echarts.init(document.getElementById(id));
            let option={
                tooltip : {
                    trigger: 'item',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
                    }
                },
                color:this.color,
                legend: {
                    data:['党员','居民'],
                    textStyle:{    //图例文字的样式
                            color:'#91b1fc',  //文字颜色
                            fontSize:12
                        },
                    itemHeight:10,
                    itemWidth:10,
                },
                grid: {
                    left: 15,
                    right: '4%',
                    bottom: '3%',
                    top:30,
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data:ecdata.label,
                        //data:ecdata.xaxis.length>5?ecdata.xaxis.slice(0,5):ecdata.xaxis,
                        axisLabel:{
                            color:'#b0b0b0',
                            fontSize:12,
                            //rotate:30,
                            formatter: (value=>{
                                return this.$util.autoSplit(value)
                            }),

                        },
                        splitLine:{show: false},//去除网格线
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        axisLabel:{
                            color:'#b0b0b0',
                            fontSize:12
                        },
                        splitLine:{
                            lineStyle:{
                                color:'#283071'
                            }
                        },//去除网格线
                        splitNumber:this.isSmallWidth?3:5
                    }
                ],
                series : [
                    // {
                    //     name:'总数',
                    //     type:'bar',
                    //     data:[350, 350, 350, 350, 350],
                    //     barWidth:18,
                    //     itemStyle:{
                    //         color:"rgba(0,0,0,.5)"
                    //     }
                    // },
                    {
                        name:'党员',
                        type:'bar',
                        //data:ecdata.dycount.length>5?ecdata.dycount.slice(0,5):ecdata.dycount,
                        data:ecdata.dyCount,
                        barWidth:7,
                    },
                    {
                        name:'居民',
                        type:'bar',
                       // data:ecdata.jmcount.length>5?ecdata.jmcount.slice(0,5):ecdata.jmcount,
                         data:ecdata.jmCount,
                        barWidth:7,
                        barGap:1,
                    },


                ]
            }
            echart.setOption(option)
            echart.on('click', (params)=>{
                this.getActivityList(params.dataIndex,params.seriesIndex)
            });
        },
      initCongtaiEcharts (ecdata) {
        var id = 'echart4' + this.index
        var echart = echarts.init(document.getElementById(id));
        let option={
          tooltip : {
            trigger: 'item',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
            }
          },
          color:this.color,
          legend: {
            data:['党员','居民'],
            textStyle:{    //图例文字的样式
              color:'#91b1fc',  //文字颜色
              fontSize:16
            },
            itemHeight:10,
            itemWidth:10,
            icon:'rect',
          },
          grid: {
            left: 15,
            right: '4%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          xAxis : [
            {
              type : 'category',
              data:ecdata.label,
              //data:ecdata.xaxis.length>5?ecdata.xaxis.slice(0,5):ecdata.xaxis,
              axisLabel:{
                color:'#b0b0b0',
                fontSize:12,
                //rotate:30,
                formatter: (value=>{
                  return this.$util.autoSplit(value)
                }),

              },
              splitLine:{show: false},//去除网格线
              axisLine:{
                lineStyle:{
                  color:'#283071'
                }
              },
              axisTick:{
                show:false,
              }
            }
          ],
          yAxis : [
            {
              type : 'value',
              axisLabel:{
                color:'#b0b0b0',
                fontSize:12
              },
              splitLine:{
                lineStyle:{
                  color:'#283071'
                }
              },
              axisLine:{
                show:false
              },
              splitNumber:this.isSmallWidth?3:5
            }
          ],
          series : [
            {
              name:'党员',
              type:'bar',
              data:ecdata.dyCount,
              barWidth:12,
              barGap:'25%'
            },
            {
              name:'居民',
              type:'bar',
              data:ecdata.jmCount,
              barWidth:12,
            },


          ]
        }
        echart.setOption(option)
        echart.on('click', (params)=>{
          this.getActivityList(params.dataIndex,params.seriesIndex)
        });
      },
        getActivityList(dataIndex,seriesIndex){
            let url = this.urlobj.communityActivityList;
            this.$post(url, {
                communityId:this.ids[dataIndex],
                appType:seriesIndex?'mst':'xfej',
                pageNum:1,
                pageSize:1000
            })
            .then(res => {
                if (res.rows.length) {
                    /* 初始化数据 */
                   let returndata = {
                       color:this.color[seriesIndex],
                       list:res.rows.map(item=>{
                           return {
                              id:item.id,
                              name:item.title,
                              position:item.coordinate,
                              opacity:(Math.random()+0.3).toFixed(1),
                           }
                       })
                   }
                   console.log(returndata)
                   this.$emit('setMarkers',returndata)
                } else {
                }
            })
            .catch(e => {
                console.log(e);
            });
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.nodataBox{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #b0b0b0;
    height: 100%;
}
</style>
